/**
 * @param {[string, any][]} entries
 * @returns {FormData}
 */
const fromPairs = (entries) => entries.reduce((data, [key, value]) => (data.append(key, value), data), new FormData())

/**
 *
 * @param { FormData | [string, any][] | object } data
 * @returns { FormData }
 */
const formData = (data) => {
	if (data instanceof FormData)
		return data

	if (Array.isArray(data))
		return fromPairs(data)

	return fromPairs(Object.entries(data))
}

export default formData
